// extracted by mini-css-extract-plugin
export default {"contents":"vE-z","sectionHeading":"wE-z"};